import { Component } from '@angular/core';

@Component({
    selector: 'app-moving-background',
    templateUrl: './moving-background.component.html'
})
export class MovingBackgroundComponent {}
